export const API_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
